module.exports = __webpack_public_path__ + "img/contact_inquiry.0cacb23c.png";